import VisitorData from '../helpers/visitor-data';

export default function doNotTrackDimension(): void {
    Analytics.set('do_not_track', VisitorData.getBrowserDNT());
}
